module.exports = __webpack_public_path__ + "img/koniec@tab.5dd132fc.png";